import styled from "styled-components";

export const ShimmerContainer = styled.div(({ theme }) => ({
    width: "100%",
    minHeight: "100vh",
    backgroundColor: theme.colors[theme.colorMode].canvas_Primary,
    color: theme.colors[theme.colorMode].text_inverse_Highest_Emphasis,
    display: "flex",
    flexDirection: "column",
}));

export const ShimmerContent = styled.div(({ theme }) => ({
    width: "100%",
    flex: 1,
    padding: `${theme.spacing.xLarge} ${theme.spacing.large}`,
    paddingTop: `calc(var(--sat, 0px) + ${theme.spacing.medium})`,
    background: `linear-gradient(to bottom, ${theme.colors[theme.colorMode].canvas_Primary} 0%, ${
        theme.colors[theme.colorMode].background_Secondary
    } 100%)`,
}));

export const ShimmerBlock = styled.div<{ height: number; marginBottom: number }>(({ theme, height, marginBottom }) => ({
    height: `${height}px`,
    marginBottom: `${marginBottom}px`,
    backgroundColor: theme.colors[theme.colorMode].background_Secondary_Alpha,
    borderRadius: theme.spacing.small,
    padding: theme.spacing.medium,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
}));

export const ShimmerFooter = styled.div<{ height: number; marginBottom: number }>(
    ({ theme, height, marginBottom }) => ({
        height: `${height}px`,
        marginBottom: `calc(${marginBottom}px + var(--sab, 0px))`,
        backgroundColor: theme.colors[theme.colorMode].background_Secondary_Alpha,
        borderRadius: theme.spacing.small,
        padding: theme.spacing.medium,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        position: "fixed",
        width: "90%",
        bottom: theme.spacing.empty,
    }),
);
